unit SMX.Web.Jobs.Utils;

interface

uses
  System.SysUtils,
  System.DateUtils,
  System.StrUtils,
  Data.DB;

const
  JOB_STALL_MINUTES = 10;
  { UI-only stall label/styling. When False, jobs keep showing Processing (etc.). }
  JOB_STALL_REPORTING_ENABLED = False;

function JobStatusIsActive(const AStatus: string): Boolean;
function JobStatusIsTerminal(const AStatus: string): Boolean;
{ Failed/Cancelled(/Error) for UI fill and hiding %/result stats. Complete is not included. }
function JobStatusIsStopped(const AStatus: string): Boolean;
function JobStatIsOutcomeState(const ACaption: string): Boolean;
function JobActivityTime(ADataset: TDataSet): TDateTime;
function JobIsStalled(ADataset: TDataSet): Boolean; overload;
function JobIsStalled(const AStatus: string; const ALastUpdated, ADateRun,
  ADateSubmitted: TDateTime): Boolean; overload;
function FormatJobProgress(const AProgress: Double): string;
function FormatJobProgressBarHtml(const AProgress: Double;
  AStalled: Boolean = False; const AEmptyLabel: string = '';
  AFillWithoutPercent: Boolean = False): string;
function JobStatusCssClass(ADataset: TDataSet): string;
function JobTypeCssClass(const AJobType: string): string;
function JobStatusDisplay(ADataset: TDataSet): string;

implementation

function JobStatusIsTerminal(const AStatus: string): Boolean;
begin
  Result := SameText(AStatus, 'Complete') or SameText(AStatus, 'Failed') or
    SameText(AStatus, 'Cancelled') or SameText(AStatus, 'NothingToDo') or
    SameText(AStatus, 'Processed') or SameText(AStatus, 'Preview');
end;

function JobStatusIsStopped(const AStatus: string): Boolean;
begin
  Result := SameText(AStatus, 'Failed') or SameText(AStatus, 'Cancelled') or
    SameText(AStatus, 'Error');
end;

function JobStatIsOutcomeState(const ACaption: string): Boolean;
begin
  Result := SameText(ACaption, 'Outcome') or SameText(ACaption, 'State') or
    SameText(ACaption, 'Rollback') or SameText(ACaption, 'RollBack') or
    ContainsText(ACaption, 'Rollback');
end;

function JobStatusIsActive(const AStatus: string): Boolean;
begin
  Result := (AStatus <> '') and (not JobStatusIsTerminal(AStatus));
end;

function JobActivityTime(ADataset: TDataSet): TDateTime;
var
  lField: TField;
begin
  Result := 0;
  if not Assigned(ADataset) then
    Exit;

  lField := ADataset.FindField('LastUpdated');
  if Assigned(lField) and (not lField.IsNull) and (lField.AsDateTime > 100) then
    Exit(lField.AsDateTime);

  lField := ADataset.FindField('DateRun');
  if Assigned(lField) and (not lField.IsNull) and (lField.AsDateTime > 100) then
    Exit(lField.AsDateTime);

  lField := ADataset.FindField('DateSubmitted');
  if Assigned(lField) and (not lField.IsNull) then
    Result := lField.AsDateTime;
end;

function JobIsStalled(const AStatus: string; const ALastUpdated, ADateRun,
  ADateSubmitted: TDateTime): Boolean;
var
  lActivity: TDateTime;
begin
  Result := False;
  if not JOB_STALL_REPORTING_ENABLED then
    Exit;
  if not JobStatusIsActive(AStatus) then
    Exit;

  { New/Queued jobs are waiting their turn — DateSubmitted silence is not a stall. }
  if SameText(AStatus, 'New') or SameText(AStatus, 'Queued') then
    Exit;

  { Only processing-class statuses use last_updated/date_run heartbeats. }
  lActivity := ALastUpdated;
  if (lActivity < 100) then
    lActivity := ADateRun;
  if lActivity < 100 then
    Exit;

  Result := MinutesBetween(Now, lActivity) >= JOB_STALL_MINUTES;
end;

function JobIsStalled(ADataset: TDataSet): Boolean;
var
  lStatus: string;
  lLastUpdated, lDateRun, lDateSubmitted: TDateTime;
  lField: TField;
begin
  Result := False;
  if not Assigned(ADataset) or ADataset.IsEmpty then
    Exit;

  lStatus := ADataset.FieldByName('Status').AsString;
  lLastUpdated := 0;
  lDateRun := 0;
  lDateSubmitted := 0;

  lField := ADataset.FindField('LastUpdated');
  if Assigned(lField) and (not lField.IsNull) then
    lLastUpdated := lField.AsDateTime;
  lField := ADataset.FindField('DateRun');
  if Assigned(lField) and (not lField.IsNull) then
    lDateRun := lField.AsDateTime;
  lField := ADataset.FindField('DateSubmitted');
  if Assigned(lField) and (not lField.IsNull) then
    lDateSubmitted := lField.AsDateTime;

  Result := JobIsStalled(lStatus, lLastUpdated, lDateRun, lDateSubmitted);
end;

function FormatJobProgress(const AProgress: Double): string;
begin
  if AProgress <= 0 then
    Result := ''
  else if AProgress >= 100 then
    Result := '100%'
  else
    Result := FormatFloat('0', AProgress) + '%';
end;

function FormatJobProgressBarHtml(const AProgress: Double;
  AStalled: Boolean; const AEmptyLabel: string;
  AFillWithoutPercent: Boolean): string;
var
  lPct, lWidth: Integer;
  lLabel, lSideLabel, lBarClass, lSideHtml: string;
begin
  if AFillWithoutPercent then
  begin
    { Cancelled: amber track at actual progress (or empty), never force 100%. }
    if AProgress <= 0 then
      lWidth := 0
    else if AProgress >= 100 then
      lWidth := 100
    else
      lWidth := Trunc(AProgress);
    Result := Format(
      '<div class="job-progress-wrap">' +
      '<div class="progress job-progress-bar">' +
      '<div class="progress-bar bg-warning" role="progressbar" style="width:%d%%" ' +
      'aria-valuenow="%d" aria-valuemin="0" aria-valuemax="100"></div></div></div>',
      [lWidth, lWidth]);
    Exit;
  end;

  if AProgress <= 0 then
    lPct := 0
  else if AProgress >= 100 then
    lPct := 100
  else
    lPct := Trunc(AProgress);

  lLabel := FormatJobProgress(AProgress);
  if lLabel = '' then
    lLabel := AEmptyLabel;
  lSideLabel := '';

  if AStalled then
  begin
    lBarClass := 'progress-bar bg-warning text-dark';
    if lLabel = '' then
      lLabel := 'Stalled'
    else if Pos('Stalled', lLabel) = 0 then
      lLabel := 'Stalled ' + lLabel;
  end
  else if lPct >= 100 then
    lBarClass := 'progress-bar bg-success'
  else
    lBarClass := 'progress-bar';

  lWidth := lPct;
  if lPct <= 0 then
  begin
    { Empty track; put Waiting/Stalled beside the bar so it isn't cramped. }
    lWidth := 0;
    lSideLabel := lLabel;
    lLabel := '';
  end
  else if (lLabel <> '') and (lWidth < 12) then
    lWidth := 12;

  if lSideLabel <> '' then
    lSideHtml := '<span class="job-progress-label">' + lSideLabel + '</span>'
  else
    lSideHtml := '';

  Result := Format(
    '<div class="job-progress-wrap">' +
    '<div class="progress job-progress-bar">' +
    '<div class="%s" role="progressbar" style="width:%d%%" ' +
    'aria-valuenow="%d" aria-valuemin="0" aria-valuemax="100">%s</div></div>%s</div>',
    [lBarClass, lWidth, lPct, lLabel, lSideHtml]);
end;

function JobStatusCssClass(ADataset: TDataSet): string;
begin
  if not Assigned(ADataset) or ADataset.IsEmpty then
    Exit('');

  if JobIsStalled(ADataset) then
    Exit('Stalled');

  Result := ADataset.FieldByName('Status').AsString;
end;

function JobTypeCssClass(const AJobType: string): string;
begin
  if ContainsText(AJobType, 'ImportMerge') then
    Result := 'job-type-merge'
  else if ContainsText(AJobType, 'ImportCancel') then
    Result := 'job-type-cancel'
  else if ContainsText(AJobType, 'DonationImport') then
    Result := 'job-type-import'
  else if ContainsText(AJobType, 'PrepareClaim') then
    Result := 'job-type-prepare'
  else if ContainsText(AJobType, 'GiftAidClaim') or ContainsText(AJobType, 'ClaimGiftAid') then
    Result := 'job-type-claim'
  else if ContainsText(AJobType, 'MarkPaid') then
    Result := 'job-type-markpaid'
  else
    Result := 'job-type-other';
end;

function JobStatusDisplay(ADataset: TDataSet): string;
var
  lProgress: string;
  lField: TField;
begin
  if not Assigned(ADataset) or ADataset.IsEmpty then
    Exit('');

  if JobIsStalled(ADataset) then
    Result := 'Stalled'
  else
    Result := ADataset.FieldByName('Status').AsString;

  if SameText(Result, 'Cancelled') then
    Exit;

  lField := ADataset.FindField('Progress');
  if Assigned(lField) and (not lField.IsNull) then
  begin
    lProgress := FormatJobProgress(lField.AsFloat);
    if lProgress <> '' then
      Result := Result + ' (' + lProgress + ')';
  end;
end;

end.
